import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#i-1170153552__a)" }, [
      _createElementVNode("path", {
        fill: "#fa7e14",
        d: "M19.593 21.546c-.146.209-.27.38-.388.554l-5.68 8.38q-2.641 3.897-5.288 7.79a.36.36 0 0 1-.251.147 1675 1675 0 0 1-7.471-.081c-.028 0-.057-.009-.11-.017q.03-.078.069-.152l5.212-8.097q2.312-3.588 4.626-7.173 2.565-3.984 5.127-7.973c.252-.393.514-.777.754-1.177a.49.49 0 0 0 .051-.353c-.46-1.47-.93-2.938-1.398-4.405-.2-.628-.41-1.253-.599-1.885-.06-.203-.16-.265-.368-.264-1.565.007-3.12.005-4.68.005-.297 0-.298 0-.298-.293q.002-2.884-.006-5.769c0-.214.07-.262.27-.262q4.714.009 9.428 0a.3.3 0 0 1 .33.224 53675 53675 0 0 0 10.771 27.132c.6 1.512 1.205 3.022 1.8 4.537.07.184.144.22.33.162 1.646-.51 3.297-1.006 4.943-1.517.207-.065.283-.022.347.184.562 1.769 1.134 3.534 1.703 5.3.02.062.034.123.057.208-.118.044-.228.093-.341.124l-11.225 3.569c-.178.056-.232-.005-.291-.155q-1.714-4.351-3.435-8.699l-3.37-8.514-.502-1.28c-.027-.073-.064-.137-.117-.25"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i-1170153552__a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 .5h39v40H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }